/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_ResetInputs */

const en_disp_reset = /** @type {(inputs: Disp_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset to defaults`)
};

const de_disp_reset = /** @type {(inputs: Disp_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Standard zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset to defaults" |
*
* @param {Disp_ResetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_reset = /** @type {((inputs?: Disp_ResetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_ResetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_reset(inputs)
	return en_disp_reset(inputs)
});